import { FaPenToSquare, FaEye } from "react-icons/fa6";

const InfoSummeryBand = ({ band }) => {
  return (
    <div className="grid sm:grid-cols-8 grid-cols-4 items-center py-3 px-4">
      <p className="col-span-2 sm:col-span-5 font-medium truncate">
        {band.name}
      </p>
      <div className="col-span-1 flex justify-center">
        <span
          className={`badge badge-sm ${band.visible ? "badge-success" : "badge-ghost"}`}
        >
          {band.visible ? "Ja" : "Nej"}
        </span>
      </div>
      <div className="col-span-1 flex justify-center">
        <a href={`userprofile/band?slug=${band.slug}`}>
          <button className="btn btn-ghost btn-xs">
            <FaPenToSquare size={15} />
          </button>
        </a>
      </div>
      <div className="col-span-1 flex justify-center">
        <a href={`/music/${band.slug}`}>
          <button className="btn btn-ghost btn-xs">
            <FaEye size={15} />
          </button>
        </a>
      </div>
    </div>
  );
};

export default InfoSummeryBand;
